import { render, staticRenderFns } from "./project-weekly-choose-contact.vue?vue&type=template&id=359d5ecd&scoped=true&"
import script from "./project-weekly-choose-contact.vue?vue&type=script&lang=js&"
export * from "./project-weekly-choose-contact.vue?vue&type=script&lang=js&"
import style0 from "./project-weekly-choose-contact.vue?vue&type=style&index=0&id=359d5ecd&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359d5ecd",
  null
  
)

export default component.exports